import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, Renderer2, ViewChild } from '@angular/core'
import { AbstractValidator, ICell, IColumn, IValidationError } from '../validators/abstract-validator.interface'
import { BehaviorSubject, Observable, Subject } from 'rxjs'
import { FormControl } from '@angular/forms'
import { map } from 'rxjs/operators'
import { CommonService } from 'src/app/services/common/common.service'
import * as $ from 'jquery'
import { DOCUMENT } from '@angular/common'
import { ExcelService } from 'src/app/services/excel/excel.service'
import { DocumentService } from 'src/app/services/common/document.service'
import { ServiceUrlConstants } from 'src/app/constants/service-url-constants'
import cloneDeep from 'lodash/cloneDeep'

interface IFileReadStatus {
  error: boolean
  message: string
}

interface IRows {
  countGood: number
  countBad: number
  messages?: string[]
  saved: Subject<boolean>
  data?: [
    {
      saveStatus?: number // 2 unsaved, 1 successfully saved, 0 failed to save
      saveMessage?: string
      tJSON?: any
      filedata?: any[]
      filelength?: any
      indexNo?: any
      selected: boolean
    }
  ]
}

interface ISummaryError {
  flag: boolean // true for error, false for good
  message: string
}

interface ITableCell {
  cell?: ICell
  fControl?: FormControl
  errSummary: BehaviorSubject<ISummaryError>
}

@Component({
  selector: 'app-bulk-import',
  templateUrl: './bulk-import-component.html',
  styleUrls: ['./bulk-import-component.scss']
})
export class BulkImportComponent implements OnInit {
  @ViewChild('preview', { read: ElementRef }) previewDiv: ElementRef

  @Input() validator: AbstractValidator<any>
  @Input() close = true
  @Input() showNavBar = true
  @Input() showLeftMenu = true
  @Output() importClose = new EventEmitter<boolean>()

  title$: BehaviorSubject<string> = new BehaviorSubject<string>('')
  stepTitle$: BehaviorSubject<string> = new BehaviorSubject<string>('')
  doRead$: Subject<{ file: File; sheetName: string }> = new Subject()
  doImport$: Subject<File> = new Subject()
  columns$: BehaviorSubject<IColumn[]> = new BehaviorSubject<IColumn[]>([])
  doReadHeaders$ = new Subject()
  fileName$: BehaviorSubject<any> = new BehaviorSubject<any>({ name: '', changed: false })
  doneValidation$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false)
  fileReadStatus$: BehaviorSubject<IFileReadStatus> = new BehaviorSubject<IFileReadStatus>({
    error: false,
    message: ''
  })
  rowsReadStatus$: BehaviorSubject<IFileReadStatus> = new BehaviorSubject<IFileReadStatus>({
    error: false,
    message: ''
  })

  sheetNames: string[]
  selectedFile: File = null
  selectedSheetName: string
  screenName$: String = ''
  fileSize: number
  dataRows: any[] = []
  doneReading: boolean
  readError: boolean
  currentPage: number = 1
  itemsPerPage: number = 10
  totalItems: number
  rowsToSave: IRows = {
    countGood: 0,
    countBad: 0,
    messages: [],
    saved: new Subject<boolean>(),
    data: [{ saveStatus: 0, saveMessage: '', tJSON: {}, selected: true }]
  }
  headerCheck: IColumn[]
  internalColumns: any[] = []

  fileColumns: string[]
  head: any // temp holder for header row.
  formGrid: Map<number, ITableCell> = new Map<number, ITableCell>()
  hasValidationError = false
  inData: AbstractValidator<any>
  fileType = ''
  uploadSelectedFiles = []
  hasInputError: boolean
  arrayBuffer: any
  headers = []
  filelist: any[]
  isSelectAllChecked = true
  selectedDocumentFile: File
  headerFilters = {}
  filteredDataRows: any
  sortDirection: { [column: string]: 'ASC' | 'DESC' } = {}
  currentStep: number = 1

  private readonly CSV = 'csv'
  apiResponse: any
  //Do not mutate originalDataRows
  originalDataRows: ReadonlyArray<any>

  constructor(
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private excelService: ExcelService,
    private cs: CommonService,
    private documentService: DocumentService
  ) {
    this.hasInputError = false
    this.fileSize = 200
    this.readError = false
    this.doneReading = false
  }

  ngOnInit(): void {
    this.renderer.addClass(this.document.body, 'bulkimportactivitypges')
    this.onDoRead()
    this.onDoReadHeaders()
    this.setValidator()
    this.onDoImport()
    this.subscribeAPIResponse()
    this.subscribeFileReadAndRowReadStatus()
  }

  prevClick(step: number) {
    this.currentStep = step
  }

  nextClick(step: number) {
    const defaultTabStyles = { backgroundColor: '#0452d7', color: '#ffffff', border: '2px solid #0452D7' }

    switch (step) {
      case 1:
        this.updateTabStyles(['#step2-tab'], {
          backgroundColor: '#E5EFFF',
          color: '#0452d7',
          border: '1px solid #0452D7'
        })
        break
      case 2:
        this.updateTabStyles(['#step1-tab', '#step2-tab'], defaultTabStyles)
        this.updateTabStyles(['#step3-tab'], {
          backgroundColor: '#E5EFFF',
          color: '#0452d7',
          border: '1px solid #0452D7'
        })
        break
      case 3:
        if (this.currentStep === 2) {
          const unmatchedCol = this.isColumnsUnmatched()
          if (unmatchedCol) {
            this.cs.showInfo('All fields need to be mapped to columns before continuing')
            return
          }
          this.updateTabStyles(['#step1-tab', '#step2-tab', '#step3-tab'], defaultTabStyles)
          this.dataRows.forEach(dataRow => (dataRow.isSelected = true))
          this.OnStepValidateRows()
        }
        break
      case 4:
        if (this.dataRows.every(dataRow => !dataRow?.isSelected)) {
          return this.cs.showError('Please select atleast one row')
        }
        this.updateTabStyles(['#step1-tab', '#step2-tab', '#step3-tab'], defaultTabStyles)
        this.onConfirmData()
        if (this.hasValidationError) {
          this.currentStep = 3
          return this.cs.showError('Some of the fields have validation issues')
        }
        if (!this.validator.document.showUpload) {
          step = 5
          setTimeout(() => {
            this.nextClick(5)
          }, 10)
        }
        break
      case 5:
        this.filteredDataRows = this.dataRows
        //this.doneValidation$.next(false)
        //this.OnStepValidateRows(false, true)
        //this.onConfirmData()
        this.doneValidation$.next(true)
        if (this.hasValidationError) {
          return
        }
        this.doDataImport()
        this.updateTabStyles(['#step1-tab', '#step2-tab', '#step3-tab', '#step4-tab'], defaultTabStyles)
        break
      default:
        break
    }

    this.currentStep = step
  }

  private isColumnsUnmatched() {
    return this.headerCheck.filter(hc => hc.doInclude).find(c => c.fileColIndex < 0) ? true : false
  }

  private updateTabStyles(tabIds: string[], styles: any) {
    tabIds.forEach(tabId => {
      const element = document.querySelector(tabId)
      if (element) {
        Object.keys(styles).forEach(style => this.renderer.setStyle(element, style, styles[style]))
      }
    })
  }

  upload() {
    $('.biast1t').hide()
    $('.biast1b').show()
    if (this.selectedFile) {
      this.excelService
        .getSheetNames(this.selectedFile)
        .then(sheetNames => {
          this.sheetNames = sheetNames
          this.cs.showSuccess(`Successfully uploaded ${this.selectedFile.name}`)
        })
        .catch(error => {
          this.cs.showError('Error reading the file:', error)
        })
    }
  }

  onFileSelected(event: any) {
    const file: File = event.target.files[0]

    const isValidFile = [
      'application/vnd.ms-excel',
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'text/csv'
    ].includes(file.type)
    if (!isValidFile) {
      this.cs.showError(`Invalid File format`)
      return
    }

    this.selectedFile = file
  }

  onDocumentZipSelected(event: any) {
    this.selectedDocumentFile = event.target.files[0]
  }

  uploadDocumentZipFile() {
    this.validator.document.file$.next(this.selectedDocumentFile)
    this.nextClick(5)
  }

  onSheetNameChange(sheetName: string) {
    this.selectedSheetName = sheetName
  }

  doStartImporting() {
    this.doRead$.next({ file: this.selectedFile, sheetName: this.selectedSheetName })
  }

  private onDoRead() {
    this.doRead$.subscribe(({ file, sheetName }) => {
      this.doneReading = false
      delete this.head
      const reader = new FileReader()
      if (this.fileType == this.CSV) {
        reader.addEventListener('loadend', () => {
          const fileText = reader.result as string
          this.arrayBuffer = reader.result
          const regEx = RegExp('[^\\n\\r-ÿ]', 'gm')
          const errorCharacters = regEx.exec(fileText)
          if (errorCharacters && errorCharacters.length) {
            const errorRow = fileText.substring(0, regEx.lastIndex).split('\n').length
            const message = `Found unreadable character ${errorCharacters[0]} at row number ${errorRow}. Please remove it from file and upload file again`
            this.fileReadStatus$.next({ error: true, message })
          }
          this.dataRows = fileText.trim().split('\n')
          this.filteredDataRows = fileText.trim().split('\n')
          this.originalDataRows = cloneDeep(fileText.trim().split('\n'))
          if (this.dataRows.length === 0) {
            this.fileReadStatus$.next({ error: true, message: 'No data rows found in the file' })
          } else {
            this.doneReading = true
            this.doReadHeaders$.next(true)
          }
        })
        reader.addEventListener('error', () => {
          this.readError = true
          console.error('error in reading file')
        })
        reader.readAsText(file, 'utf8')
      } else {
        reader.readAsArrayBuffer(file)
        reader.onload = e => {
          this.arrayBuffer = reader.result
          const data = new Uint8Array(this.arrayBuffer)
          const arr = new Array()
          for (let i = 0; i != data.length; i++) {
            arr[i] = String.fromCharCode(data[i])
          }
          const bstr = arr.join('')
          const workbook = this.excelService.readExcelFromBinaryString(bstr)
          const worksheet = workbook.Sheets[sheetName]
          const arraylist = this.excelService.sheetToJSON(worksheet, { raw: false })
          arraylist.forEach(row => {
            Object.keys(row).forEach(col => {
              const val = row[col]
              if (typeof val === 'string' && val.includes('/') && /^\d{1,2}\/\d{1,2}\/\d{2,5}$/.test(val)) {
                row[col] = this.excelService.normalizeExcelDate(val)
              }
            })
          })

          const range = this.excelService.decodeWorksheetRange(worksheet, '!ref')
          let C
          const R = range.s.r

          for (C = range.s.c; C <= range.e.c; ++C) {
            const cell = this.excelService.getCellByIndexes(worksheet, R, C)
            let hdr = 'UNKNOWN ' + C // <-- replace with your desired default
            if (cell && cell.t) {
              hdr = this.excelService.formatCell(cell)
            }

            this.headers.push(hdr)
          }
          this.dataRows = arraylist
          this.filteredDataRows = arraylist
          this.originalDataRows = cloneDeep(arraylist)
          if (this.dataRows.length === 0) {
            console.error('read error')
            this.fileReadStatus$.next({ error: true, message: 'No data rows found in the file' })
          } else {
            this.doneReading = true
            this.doReadHeaders$.next(true)
          }
        }
      }
    })
  }

  private onDoReadHeaders() {
    this.doReadHeaders$.subscribe(() => {
      if (this.doneReading && this.dataRows) {
        if (this.fileType == this.CSV) {
          this.fileColumns = this.dataRows[0].replace(/\s+/g, ' ').trim().split(',')
        } else {
          this.fileColumns = this.headers
        }
        const result = this.inData.checkHeaders(this.fileColumns)
        if (result instanceof Array) {
          this.headerCheck = result as Array<IColumn>
          this.headerCheck.forEach(header => header.isFilterable && (this.headerFilters[header.column] = ''))
          this.columns$.next(result)
          this.doneValidation$.next(false)
          this.rowsReadStatus$.next({ error: false, message: '' })
        } else {
          const err = result as IValidationError
          this.fileReadStatus$.next({ error: true, message: err.message })
        }
      }
      this.nextClick(2)
    })
  }

  private setValidator() {
    if (this.validator) {
      this.inData = this.validator
      if (this.inData && this.inData.saveResponse) {
        this.title$.next(`${this.inData.title}`)
        this.inData.uploadTitle = this.inData.uploadTitle ?? 'Upload'
        this.inData.saveResponse
          .pipe(
            map((r, i) => {
              if (i < this.rowsToSave.data.length) {
                this.rowsToSave.data[i].saveStatus = r.status
                return r
              } else {
                return null
              }
            })
          )
          .subscribe(res => {
            if (res && res.status === 1) {
              if (this.screenName$ != '') {
                this.rowsToSave.countGood = res.result.success
                this.rowsToSave.countBad = res.result.failure
              } else {
                this.rowsToSave.countGood++
              }
            } else if (res) {
              if (this.screenName$ != '') {
                this.rowsToSave.countGood = res.result.success
                this.rowsToSave.countBad = res.result.failure
              } else {
                this.rowsToSave.countBad++
                this.rowsToSave.messages.push(res.description)
              }
            }
            if (this.rowsToSave.countBad + this.rowsToSave.countGood === this.rowsToSave.data.length) {
              this.rowsToSave.saved.next(true)
            }
          })
      }
    }
  }

  OnChangeColMap(fileColumnIndex: string, index: number): void {
    // find the key that user has mapped this col to
    // and change the fileColIndex of that column to
    // the value of the selected option.
    const i = Number(fileColumnIndex)
    const fileIndex = this.headerCheck[index].fileColIndex
    this.headerCheck[index].fileColIndex = i
    this.filteredDataRows.forEach((dataRow, idx) => {
      const val = this.originalDataRows[idx][this.fileColumns[i]]
      dataRow[this.headerCheck[index].column] = val
    })

    this.dataRows.forEach((dataRow, idx) => {
      const val = this.originalDataRows[idx][this.fileColumns[i]]
      dataRow[this.headerCheck[index].column] = val
    })
  }

  doDataImport(): void {
    if (this.rowsToSave instanceof Array) {
      this.rowsToSave.map(dataRow => (dataRow.isSelected = true))
    }
    // get the JSON object in array and send to repository for save.
    this.doImport$.next(null)
  }

  onConfirmData(): void {
    // we need to update row.columns.value to the value typed in the formcontrols.
    // build a row again, and send to validateRow function
    this.hasValidationError = false
    this.formGrid.forEach((tc, key) => {
      if (tc.fControl.dirty) {
        tc.cell.col.value = tc.fControl.value
        if (tc.cell.col.inValues) {
          tc.fControl.patchValue(tc.cell.col.inValues.find(v => v.match === tc.cell.col.value)?.display)
        }
        this.rowsToSave.data[tc.cell.rowIndex].tJSON[tc.cell.col.key] = tc.cell.col.value

        tc.cell.col.allErrors = this.inData.validateColumn(tc.cell.col)
        this.setColErrors(tc.cell.col.allErrors, tc.errSummary, key)
      } else {
        if (tc.errSummary.getValue().flag) {
          this.hasValidationError = true
        }
      }
    })
  }

  private onDoImport() {
    this.doImport$.subscribe(() => {
      this.rowsToSave.saved.next(false)

      const selectedRowsToSave = this.rowsToSave.data
        .filter(rowToSave => rowToSave.selected)
        .map(rowToSave => {
          delete rowToSave?.tJSON?.isSelected
          return rowToSave.tJSON
        })

      if (this.inData.allRows) {
        this.inData.allRows.next(selectedRowsToSave)
        //this.inData.allRows.complete()
      }
      if (this.inData.eachValue) {
        if (this.screenName$ != '') {
          this.filteredDataRows.saved.next(false)
          const i = 0
          selectedRowsToSave.forEach((r, i) => {
            if (i == 0) {
              r.filedata = this.uploadSelectedFiles
              this.inData.eachValue.next(r)
            }
          })
        } else if (this.fileType == this.CSV) {
          selectedRowsToSave.forEach(r => {
            r.filedata = this.uploadSelectedFiles
            this.inData.eachValue.next(r)
          })
        } else {
          let i = 1
          selectedRowsToSave.forEach(r => {
            r.filedata = this.uploadSelectedFiles
            r.filelength = this.filteredDataRows.data.length
            r.indexNo = i
            this.inData.eachValue.next(r)
            i = i + 1
          })
        }
      }
      this.validator.startImporting$.next(true)
    })
  }

  setColErrors(
    errors: Observable<IValidationError>[],
    errSubject: BehaviorSubject<ISummaryError>,
    key: number = null
  ): void {
    const retStatus: ISummaryError = { flag: false, message: '' }
    errors.forEach(colErr => {
      colErr.subscribe(v => {
        if (v.status === 0) {
          retStatus.flag = true
          retStatus.message = v.message
          this.hasValidationError = true
          errSubject.next(retStatus)
        }
      })
    })
    if (!retStatus.flag) {
      errSubject.next(retStatus)
    }
  }

  OnStepValidateRows(createNewObj: boolean = true, useSelectedFromObj: boolean = false): void {
    // do this on the step only when we have not done the validations before otherwise just skip since user
    // may be doing back and forth.
    if (!this.doneValidation$.getValue()) {
      if (this.rowsToSave && createNewObj) {
        delete this.rowsToSave.saved
        delete this.rowsToSave.data
        delete this.rowsToSave
        this.rowsToSave = {
          countGood: 0,
          countBad: 0,
          messages: [],
          saved: new Subject<boolean>(),
          data: [{ saveStatus: 0, saveMessage: '', tJSON: {}, selected: true }]
        }
      }

      if (this.formGrid) {
        this.formGrid.clear()
      }
      // calculate min columns required in the row based on col map
      // this should be at least the number of unique cols that will be mapped to data
      const minCols = this.headerCheck
        .filter(h => h.doInclude)
        .map(hc => hc.fileColIndex)
        .reduce((p, c, i) => {
          c = c + 1
          c > p ? (p = c) : ''
          return p
        })
      // first setup the map of column and key. In case user changed it (?? add check if changes are done).
      this.hasValidationError = false
      if (this.fileType == this.CSV) {
        this.head = this.head ? this.head : this.filteredDataRows.shift()
      }
      this.rowsToSave.data = [{ saveStatus: 0, saveMessage: '', tJSON: {}, selected: true }]

      for (let rI = 0; rI < this.filteredDataRows.length; rI++) {
        const isSelected = useSelectedFromObj ? this.filteredDataRows[rI]?.isSelected : createNewObj
        this.rowsToSave.data[rI] = { saveStatus: 2, tJSON: {}, selected: isSelected }
        this.filteredDataRows[rI].index = rI
        let values
        if (this.fileType == this.CSV) {
          values = this.filteredDataRows[rI].trim().split(',')
          if (values < minCols) {
            this.rowsReadStatus$.next({ error: true, message: `Row number - ${rI} has missing values, please check` })
            return
          }
        }
        this.rowsToSave.data[rI].tJSON.isSelected = this.filteredDataRows[rI]?.isSelected

        const includedCols = this.headerCheck.filter(hc => hc.doInclude)
        for (let cI = 0; cI < includedCols.length; cI++) {
          const cell: ICell = { rowIndex: rI, colIndex: cI }
          const es = new BehaviorSubject<ISummaryError>({ flag: false, message: '' })
          cell.col = Object.assign({}, includedCols[cI])
          if (this.fileType == this.CSV) {
            cell.col.value = values[includedCols[cI].fileColIndex]
          } else {
            cell.col.value = this.filteredDataRows[rI][cell.col.column]
          }

          this.rowsToSave.data[rI].tJSON[cell.col.key] = cell.col.value

          const mapKey = (rI + 1) * 1000 + cI
          const f = new FormControl('')
          if (cell.col.inValues) {
            f.patchValue(cell.col.inValues.find(v => v.match === cell.col.value)?.display)
          } else {
            f.patchValue(cell.col.value)
          }
          this.formGrid.set(mapKey, { cell, fControl: f, errSummary: es })
        }
      }
      this.doneValidation$.next(true)
      this.formGrid.forEach((v, key) => {
        v.cell.col.allErrors = this.inData.validateColumn(v.cell.col)
        this.setColErrors(v.cell.col.allErrors, v.errSummary, key)
      })
      this.totalItems = this.filteredDataRows.length
    }
  }

  onCloseImport(): void {
    this.importClose.emit(true)
  }

  selectAll() {
    this.filteredDataRows.forEach(dataRow => (dataRow.isSelected = this.isSelectAllChecked))
    this.rowsToSave.data.forEach(dataRow => (dataRow.selected = this.isSelectAllChecked))
  }

  syncIsAllSelectCheckbox() {
    setTimeout(() => {
      const firstNonSelectedRow = this.filteredDataRows.find(dataRow => !dataRow.isSelected)
      if (firstNonSelectedRow) {
        this.isSelectAllChecked = false
      } else {
        this.isSelectAllChecked = true
      }
    }, 0)
  }

  downloadTemplate() {
    const endPoint = `${ServiceUrlConstants.API_DOWNLOAD_TEMPLATE}${this.validator.templateName}`
    this.documentService.downloadDocument(endPoint, null, this.validator.templateName)
  }

  applyFilters() {
    const columnNames = Object.keys(this.headerFilters)
    const searchTexts = columnNames.map(columnName => this.headerFilters?.[columnName]?.toLowerCase())

    setTimeout(() => {
      this.filteredDataRows = this.dataRows.filter(item => {
        // Apply the AND operator for all filter criteria
        return columnNames.every((columnName, index) => {
          const searchText = searchTexts[index]
          return searchText === '' || item[columnName]?.toLowerCase()?.includes(searchText)
        })
      })

      //this.doneValidation$.next(false)
      this.OnStepValidateRows(false)
    }, 0)
  }

  applySort(column: IColumn) {
    if (!column.sortFn) {
      return
    }
    const columnName = column.column
    this.sortDirection[columnName] = this.sortDirection[columnName] === 'ASC' ? 'DESC' : 'ASC'

    this.filteredDataRows = column.sortFn(this.filteredDataRows, column, this.sortDirection[columnName])

    // Reset sorting for other columns
    for (const col of this.columns$.getValue()) {
      if (col.column !== columnName) {
        this.sortDirection[col.column] = undefined
      }
    }
    //this.doneValidation$.next(false)
    this.OnStepValidateRows(false)
  }

  subscribeAPIResponse() {
    this.validator.apiResponse$.subscribe(response => (this.apiResponse = response))
  }

  subscribeFileReadAndRowReadStatus() {
    this.fileReadStatus$.subscribe(({ error, message }) => {
      error && this.cs.showError(message)
    })

    this.rowsReadStatus$.subscribe(({ error, message }) => {
      error && this.cs.showError(message)
    })
  }

  viewImportedData(apiResponse: any) {
    const excelBlob: Blob = this.excelService.generateExcelFile(apiResponse?.dataList)
    const downloadLink: HTMLAnchorElement = document.createElement('a')
    downloadLink.href = URL.createObjectURL(excelBlob)
    downloadLink.download = apiResponse.fileName
    downloadLink.click()
  }

  markSelectedInRowsToSave(index: number) {
    this.rowsToSave.data[index].selected = this.filteredDataRows[index].isSelected
  }

  getCurrentPageData(): any[] {
    const startIndex = (this.currentPage - 1) * this.itemsPerPage
    return this.filteredDataRows.slice(startIndex, startIndex + this.itemsPerPage)
  }

  getPaginationRange(): number[] {
    const totalPages = Math.ceil(this.filteredDataRows.length / this.itemsPerPage)
    const maxButtons = 5
    const middleButton = Math.floor(maxButtons / 2)

    let startPage = 1
    let endPage = totalPages

    if (totalPages > maxButtons) {
      if (this.currentPage <= middleButton) {
        endPage = maxButtons
      } else if (this.currentPage >= totalPages - middleButton) {
        startPage = totalPages - maxButtons + 1
      } else {
        startPage = this.currentPage - middleButton
        endPage = this.currentPage + middleButton
      }
    }

    return Array.from({ length: endPage - startPage + 1 }, (_, index) => startPage + index)
  }

  onPageChange(newPage: number): void {
    this.currentPage = newPage
  }

  deleteSelectedFile() {
    this.selectedFile = null
  }

  setRowValidationError(row: any) {
    let flag = false
    for (let index = 0; index < this.headerCheck.length; index++) {
      const elementFlag = this.formGrid.get((row.index + 1) * 1000 + index)?.errSummary?.value?.flag
      if (elementFlag) {
        flag = elementFlag
        break
      }
    }
    row.hasValidationError = flag
  }

  ngOnDestroy(): void {
    this.title$?.unsubscribe()
    this.stepTitle$?.unsubscribe()
    this.doRead$?.unsubscribe()
    this.doImport$?.unsubscribe()
    this.doReadHeaders$?.unsubscribe()
    this.columns$?.unsubscribe()
    this.fileName$?.unsubscribe()
    this.doneValidation$?.unsubscribe()
    this.fileReadStatus$?.unsubscribe()
    this.rowsReadStatus$?.unsubscribe()
  }
}
